import { React, Component } from 'utils';
import { Creators } from 'model';

export default class Page extends Component {

	componentWillMount() {
		Creators.loading(this.props.name);
	}

	render() {
		return <div className={'page ' + this.props.name}>{this.props.children}</div>
	}
}


// WEBPACK FOOTER //
// ./src/modules/app/Page.js